"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultableToggle = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const nano_theme_1 = require("nano-theme");
const BasicTooltip_1 = require("../../../BasicTooltip");
const context_1 = require("../../../../styles/context");
const PinIcon = ({ size = 12 }) => (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true },
    React.createElement("path", { d: "M12 17v5M9 10.76a2 2 0 01-1.11 1.79l-1.78.9A2 2 0 005 15.24V16a1 1 0 001 1h12a1 1 0 001-1v-.76a2 2 0 00-1.11-1.79l-1.78-.9A2 2 0 0115 10.76V7a1 1 0 011-1 2 2 0 000-4H8a2 2 0 000 4 1 1 0 011 1z" })));
const btnClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    w: '16px',
    h: '16px',
    pad: 0,
    mar: 0,
    bd: 0,
    bg: 'transparent',
    bdrad: '4px',
    out: 'none',
    flexShrink: 0,
    trs: 'background .15s, color .15s',
});
const DefaultableToggle = ({ def, onClick }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    const label = def ? 'Override default' : 'Use default';
    return (React.createElement(BasicTooltip_1.BasicTooltip, { renderTooltip: () => t(label) },
        React.createElement("button", { type: "button", "aria-label": t(label), className: btnClass, style: { color: styles.g(0.35) }, onClick: (e) => {
                e.stopPropagation();
                onClick();
            }, onMouseEnter: (e) => {
                e.currentTarget.style.background = styles.g(0, 0.06);
            }, onMouseLeave: (e) => {
                e.currentTarget.style.background = 'transparent';
            } }, def ? (React.createElement("span", { "aria-hidden": true, style: {
                display: 'inline-block',
                width: 12,
                height: 12,
                borderRadius: '50%',
                background: 'rgba(127,127,127,0.2)',
            } })) : (React.createElement(PinIcon, { size: 12 })))));
};
exports.DefaultableToggle = DefaultableToggle;
